import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService, LanguageService } from '../../shared/services/index';
import { InspectionPlugin, Icons } from '../../shared/models';
import { Impact } from './impact.model';
import { StatesPluginFactoryService } from './states-plugin-factory.plugin';

@Injectable()
export class StatesPluginService extends InspectionPluginService {
  public impactKeys: any = [
    { value: 'Safety', label: 'point.impact.safety' },
    { value: 'Quality', label: 'point.impact.quality' },
    { value: 'Availability', label: 'point.impact.availability' },
    { value: 'Productivity', label: 'point.impact.productivity' }
  ];
  public impacts: any = [];

  public stateKeys: any = [
    { value: 0, label: 'Ok' },
    { value: 2, label: 'report.states.status.damaged' },
    { value: 3, label: 'report.states.status.dirty' },
    { value: 4, label: 'report.states.status.misaligned' },
    { value: 7, label: 'report.states.status.upgrade' },
    { value: 6, label: 'report.states.status.missing' },
    { value: 5, label: 'report.states.status.used' },
    { value: 1, label: 'report.states.status.worn' },
    { value: 8, label: 'report.states.status.lubricate' },
    { value: 9, label: 'report.states.status.further-investigation-needed' }
  ];
  public states: any = [];

  public actionKeys: any = [
    { value: 0, label: 'states.action.monitor' },
    { value: 1, label: 'states.action.calibrate' },
    { value: 2, label: 'states.action.replace' },
    { value: 3, label: 'states.action.repair' },
    { value: 4, label: 'states.action.clean' },
    { value: 5, label: 'states.action.reset' }
  ];
  public actions: any = [];

  public prioritiesKeys: any = [
    { value: 0, label: 'states.priority.extremely-critical' },
    { value: 1, label: 'states.priority.highly-critical' },
    { value: 2, label: 'states.priority.critical' },
    //{ value: -1, label: 'states.priority.none' }
  ];

  public priorities: any = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private language: LanguageService,
    private statesFactory: StatesPluginFactoryService
  ) {
    super(apiService, dataService, null, statesFactory);
    this.applyTranslation();
    this.language.onLanguageChange().subscribe((value) => {
      this.applyTranslation();
    });
  }

  public updateState(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    states: number,
    impact: Impact,
    action: number,
    criticaly: boolean,
    priority: any
  ): Observable<any> {
    const data = { states: states, impact: impact, action: action, criticaly: criticaly, priority: priority };
    return this.update(inspectionId, pointId, pluginId, data).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.processIcons(criticaly, Icons.getIconByName(Icons.statesIconName), inspectionId, pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getStates() {
    return this.states;
  }

  public getImpacts() {
    return this.impacts;
  }

  public getActions() {
    return this.actions;
  }

  public getPriorities() {
    return this.priorities;
  }

  private applyTranslation() {
    this.actions = [];
    this.impacts = [];
    this.priorities = [];
    this.states = [{ value: 0, label: 'Ok' }];
    this.copyTranslationValues(this.impactKeys, this.impacts, this.language);
    this.copyTranslationValues(this.actionKeys, this.actions, this.language);
    this.copyTranslationValues(this.prioritiesKeys, this.priorities, this.language);
    this.stateKeys.forEach((state) => {
      if (state.label !== 'Ok') {
        this.language.getValueByKey(state.label).subscribe((value) => {
          const stateValue = { ...state };
          stateValue.label = value;
          this.states.push(stateValue);
        });
      }
    });
  }

  private update(inspectionId: string, pointId: string, pluginId: string, data: any) {
    return this.statesFactory.updateState(inspectionId, pointId, pluginId, data).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
